module.exports = __webpack_public_path__ + "static/img/Four of Cups.b3f3577.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Four of Cups.jpg
// module id = 1270
// module chunks = 0